export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL ?? 'http://localhost:8080';
export const API_BASE = `${BACKEND_URL}/api`;

/** Converts a relative icon path like "/icons/salads.svg" to a full URL. */
export function iconUrl(path: string | null): string | null {
  if (!path) return null;
  if (path.startsWith('http')) return path;
  return `${BACKEND_URL}${path}`;
}

/**
 * Converts a stored product-image path to a full URL.
 * Absolute URLs (e.g. Cloudflare R2 uploads) pass through unchanged;
 * legacy relative paths ("/images/products/...") are prefixed with the backend origin.
 */
export function productImageUrl(path: string | null): string | null {
  if (!path) return null;
  if (path.startsWith('http')) return path;
  return `${BACKEND_URL}${path}`;
}
